import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, index) => {
        return (_openBlock(), _createBlock(_component_v_list_item, {
          key: index,
          onClick: ($event: any) => (_ctx.toClassChildrenRecords(child))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_content, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName) + " ", 1),
                    (child && _ctx.checkAbsence(child))
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "primary",
                          class: "mx-2",
                          outlined: "",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('attendance.attendance')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}